enum ETextOrLink {
	text = 'text',
	link = 'link',
	externalLink = 'externalLink',
	goBack = 'goBack'
}

export { ETextOrLink };
